<template>
  <v-flex xs12>

    <AudioDialogSet
      :listItems="audioPlaylists"
      :name="audioDescription"
      :show.sync="setAudioDialog.show"
      :audioId="audioId"
      :toDefault="setAudioDialog.toDefault"
      playlistType="geotag"
      @set="setAudio"
      @cancel="cancelSetDialog"
    />

    <AudioDialogUnset
      :name="audioDescription"
      :show.sync="unsetAudioDialog.show"
      :audioId="audioId"
      :fromId="listId"
      playlistType="geotag"
      @unset="unsetAudio"
      @cancel="cancelUnsetDialog"
    />

    <v-dialog
      v-model="snapshotDialog.isOpen"
      width="unset"
    >
      <v-card>
        <v-card-title>this image: {{ isNaN(snapshotDialog.width) || isNaN(snapshotDialog.height)
          ? 'undefined' : `${snapshotDialog.width} x ${snapshotDialog.height}`}}
        | origin image: {{ isNaN(snapshotDialog.originWidth) || isNaN(snapshotDialog.originHeight)
            ? 'undefined' : `${snapshotDialog.originWidth} x ${snapshotDialog.originHeight}`}}
        </v-card-title>
        <v-card-text
          class="justify-center"
        >
          <v-img
            :src="snapshotDialog.imageSrc"
          />
        </v-card-text>
        <v-card-actions
         class="justify-center"
        >
          <v-btn
            @click="closeSnapshotDialog"
            color="primary"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      width="500"
      v-model="textDialog.show"
    >
      <v-card>
        <v-card-title>{{ textDialog.type ? textDialog.type.toUpperCase() : '' }}</v-card-title>
        <v-card-text>
          <v-textarea
            v-if="textDialog.editor === 'simple'"
            v-model="textDialog.text"
            outlined
          ></v-textarea>
          <editor v-else/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="hideTextDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            :loading="textDialog.loading"
            color="blue darken-1"
            text
            @click="saveText"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row
      v-show="geotag.id"
      dense align="center"
      justify="center"
      class="text-h4"
    >
      {{ geotag.name }} (ID:{{ geotag.id }})
      {{ placenames ? placenames.en : '' }}
      <v-dialog
        v-model="placenamesDialog.show"
        width="600"
      >
        <template v-slot:activator="{}">
          <span @click="placenamesDialog.show=true" class="placenames-id">
            (P-ID:{{ geotag.placenames_id }})
          </span>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Placenames</span>
          </v-card-title>
          <v-card-text>
            <div class="subtitle-1">Assign PlaceName id to Geotag id</div>
            <div class="subtitle-2">PlaceName identifier from a database containing:
              translations, countries, airports, population, coordinates, time zones,
              Exceptions for airlines etc.</div>
            <v-text-field
              v-model="placenamesDialog.placenames_id"
              label="ID"
              type="number"
            />
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="mr-5">
              {{ placenamesDialog.isPlacenamesRequested
              ? placenamesDialog.placenamesName
              : ''}}
            </div>
            <v-btn
              :disabled="!placenamesDialog.placenames_id"
              :class="checkButtonClass"
              @click="checkPlacenamesID"
            >
              Check ID
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="placenamesDialog.show=false"
            >
              Cancel
            </v-btn>
            <v-btn
              @click="changePlacenames"
              color="blue darken-1"
              text
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="end" no-gutters>
      <v-col cols="7">

        <v-tabs
          v-model=pageTab
        >
          <v-tab>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  Videos GeoPrev
                </span>
              </template>
              GeoTag Preview for Destination Reels
            </v-tooltip>
          </v-tab>
          <v-tab>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  Images Deeplink
                </span>
              </template>
              Social Share Image
            </v-tooltip>
          </v-tab>
          <v-tab>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  Images GeoPrev
                </span>
              </template>
              GeoTag Preview for Destination Stories
            </v-tooltip>
          </v-tab>
          <v-tab>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  Images Geotag
                </span>
              </template>
              Image displayed when there are less than 3 POIs with Images
            </v-tooltip>
          </v-tab>
        </v-tabs>

        <v-tabs-items
          v-model="pageTab"
        >
          <v-tab-item>
            <v-container fluid>
              <v-row>
                <v-col>
                  <v-autocomplete
                    v-model="select.geotag"
                    :items="sequencedGeotags"
                    :filter="nonDiacriticsSensitiveFilter"
                    outlined
                    dense
                    chips
                    small-chips
                    label="Geotag"
                    return-object
                    clearable
                    hide-selected
                    item-text="name"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-avatar v-if="item.name"
                                          color="indigo"
                                          class="headline font-weight-light white--text"
                      >
                        {{ item.name.charAt(0) }}
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col>
                  <v-autocomplete
                    v-model="select.poiName"
                    :items="selectitems.poi"
                    :search-input.sync="search.poiName"
                    outlined
                    dense
                    chips
                    small-chips
                    label="POI"
                    clearable
                    hide-selected
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-avatar v-if="item"
                                          color="indigo"
                                          class="headline font-weight-light white--text"
                      >
                        {{ item.charAt(0) }}
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-text="item"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col>
                  <v-autocomplete
                    v-model="select.priority"
                    :items="[1,2,3,4,'empty']"
                    label="POI priority"
                    outlined
                    clearable
                    multiple
                    dense
                    chips
                    small-chips
                    deletable-chips
                    hide-selected
                    :menu-props="{
                      closeOnContentClick: true,
                    }"
                  />
                </v-col>

                <v-col>
                  <v-autocomplete
                    v-model="select.poiTag"
                    :items="selectitems.poiTag"
                    :search-input.sync="search.poiTag"
                    outlined
                    dense
                    chips
                    small-chips
                    label="POI Tag"
                    return-object
                    clearable
                    hide-selected
                    item-text="name"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-avatar v-if="item.name"
                                          color="indigo"
                                          class="headline font-weight-light white--text"
                      >
                        {{ item.name.charAt(0) }}
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    color="primary"
                    @click="getVideo"
                  >
                    <v-icon dark>
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-sheet
                class="mx-auto"
                elevation="8"
              >
                <v-progress-linear
                  indeterminate
                  color="cyan"
                  :active="searchloading"
                />

                <v-slide-group
                  class="pa-4"
                  show-arrows
                >
                  <v-slide-item
                    v-for="video in searchResults"
                    :key="video.id"
                    class="ma-2"
                    v-slot="{ active, toggle }"
                  >
                    <draggable
                      :group="{ name: 'videocards', put: false }"
                      :list="[video]"
                    >
                      <video-card
                        :video="video"
                        width="100"
                        @click="toggle"
                      >
                        <v-card-actions v-if="active" class="card-actions">
                          <v-btn
                            color="orange"
                            text
                            small
                            @click="addVideo(video)"
                          >
                            Add
                          </v-btn>
                        </v-card-actions>
                      </video-card>
                    </draggable>
                  </v-slide-item>
                </v-slide-group>
              </v-sheet>

              <v-row>
                <v-col>
                  <draggable
                    v-model="videoPlaylist"
                    class="fill-height playlist-content"
                    :group="{ name: 'videocards' }"
                    justify="start"
                    @change="addDraggedVideo"
                  >
                    <video-card
                      v-for="video in videoPlaylist" :key="video.id"
                      :video="video"
                      width="100"
                      class="ma-5"
                      v-slot:actions="{ activator }"
                    >
                      <v-card-actions
                        v-if="activator && !hasSomeAbilities($constants.ABILITY.INTERN)"
                        class="card-actions"
                        @click.stop="deleteVideo(video.id)"
                      >
                        <v-btn icon>
                          <v-icon
                            color="red"
                          >
                            mdi-delete
                          </v-icon>
                        </v-btn>
                      </v-card-actions>
                    </video-card>
                  </draggable>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item>
            <v-row>
              <v-col>
                <v-slide-group
                  class="mt-5"
                >
                  <v-slide-item
                    v-for="(chunkItem, chunkIndex) in chunckedSnapshotList"
                    :key="chunkIndex"
                  >
                    <v-sheet>
                      <ImageCard
                        v-for="image in chunkItem"
                        :key="image.id"
                        :item="image"
                        width="210"
                        class="ma-5"
                        @click="openSnapshotDialog(image)"
                        v-slot:actions="{ hover }"
                      >
                        <v-card-actions
                          v-if="hover && !hasSomeAbilities($constants.ABILITY.INTERN)"
                          class="card-actions"
                          @click.stop="deleteDeepLinkImage(image.id)"
                        >
                          <v-btn icon>
                            <v-icon
                              color="red"
                            >
                              mdi-delete
                            </v-icon>
                          </v-btn>
                        </v-card-actions>
                      </ImageCard>
                    </v-sheet>
                  </v-slide-item>
                </v-slide-group>
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item>
            <v-container fluid>
              <v-row>
                <media-geotag-poi-images
                  :geotag-id="geotag.id"
                  :geotag-name="geotag.name"
                />
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item>
            <v-container fluid>
              <v-row>
                <media-geotag-images
                  :geotag-id="geotag.id"
                />
              </v-row>
            </v-container>
          </v-tab-item>

        </v-tabs-items>

      </v-col>
      <v-col cols="5">
        <v-container>
          <v-row>
            <v-toolbar
              flat
              color="blue-grey"
              dark
              dense
              height="20"
            >
              <v-toolbar-title>
                Description (max {{ $constants.GEOTAG.MAX_DESCRIPTION_LENGTH }} characters)
              </v-toolbar-title>
            </v-toolbar>
            <text-card
              :text="geotag.description ? geotag.description.replaceAll('\n', '<br/>') : 'empty'"
              :min-height="100"
              v-on:remove="update(
                { description: null, show_geotag:true },
                'description'
                )"
              v-on:edit="showTextDialog('description', 'simple')"
            />

            <translations-bar
              :id="geotag.id"
              :translations="translationsDescription"
              :model="$constants.TRANSLATION_MODELS.GEOTAG_DESCRIPTION"
              title="Description"
              :trigger-update="geotag.description"
            >
            </translations-bar>
          </v-row>
          <v-row>
            <AudioList
              :listId="listId"
              :items="audioItems"
            >
              <template v-slot:top>
                <AudioDialogAdd
                  :playlist-id="`${listId}`"
                  playlist-type="geotag"
                  @addNew="addAudio"
                />
              </template>
              <template v-slot:actions="slotProps">
                <v-btn icon @click="callSetAudioDialog(slotProps.item.id)" >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <slot>
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="cyan darken-3"
                        >
                          mdi-clipboard-arrow-right-outline
                        </v-icon>
                      </slot>
                    </template>
                    set to geotag
                  </v-tooltip>
                </v-btn>
                <v-btn
                  icon
                  @click="callSetAudioDialog(slotProps.item.id, true)" >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <slot>
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="blue darken-1"
                        >
                          mdi-dropbox
                        </v-icon>
                      </slot>
                    </template>
                    set to default
                  </v-tooltip>
                </v-btn>
                <v-btn
                  icon
                  @click="callUnsetAudioDialog(slotProps.item.id)" >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <slot>
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="orange darken-4"
                        >
                          mdi-cancel
                        </v-icon>
                      </slot>
                    </template>
                    unset audio
                  </v-tooltip>
                </v-btn>
              </template>
            </AudioList>
          </v-row>
          <v-row>
            <v-toolbar
              flat
              color="blue-grey"
              dense
              dark
              height="20"
            >
              <v-toolbar-title>Distance</v-toolbar-title>
            </v-toolbar>
          </v-row>
          <v-row>
            <v-edit-dialog
              ref="distanceDialog"
            >
              <div class="my-1">
                <span>Minimal:</span>
                <span class="font-weight-black">
                   {{ geotag.distance ? geotag.distance.min : 'empty' }}
                </span>
              </div>
              <div class="my-1">
                <span>Maximal:</span>
                <span class="font-weight-black">
                  {{ geotag.distance ? geotag.distance.max : 'empty' }}
                </span>
              </div>
              <template v-slot:input>
                <v-form>
                  <v-text-field
                    v-if="geotag.distance"
                    v-model="geotag.distance.min"
                    label="Minimal distance"
                    type="number"
                    @keydown.enter.stop="updateDistance"
                    clearable
                  />
                  <v-text-field
                    v-if="geotag.distance"
                    v-model="geotag.distance.max"
                    label="Maximal distance"
                    type="number"
                    @keydown.enter.stop="updateDistance"
                    clearable
                  />
                </v-form>
              </template>
            </v-edit-dialog>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

    <v-divider class="mt-4"></v-divider>

    <v-expansion-panels v-if="placenames.ID">
      <v-expansion-panel>
        <v-expansion-panel-header>
          Placenames data
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list-item-group class="placenames-list">
            <v-list-item
              v-for="(item, key) in placenames"
              :key="key"
            >
              {{ key }}: {{ item }}
            </v-list-item>
          </v-list-item-group>

          <div v-html="placenamesExc" class="placenames-exc"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-flex>
</template>

<script>
import { mapActions } from 'vuex';
import debounce from 'lodash.debounce';
import draggable from 'vuedraggable';
import MediaGeotagImages from '@/components/MediaGeotagImages.vue';
import MediaGeotagPoiImages from '@/components/MediaGeotagPoiImages.vue';
import AudioDialogSet from '../components/dialogs/AudioDialogSet.vue';
import AudioDialogUnset from '../components/dialogs/AudioDialogUnset.vue';
import AudioList from '../components/AudioList.vue';
import AudioDialogAdd from '../components/dialogs/AudioDialogAdd.vue';
import VideoCard from '../components/VideoCard.vue';
import ImageCard from '../components/ImageCard.vue';
import TextCard from '../components/TextCard.vue';
import Editor from '../components/Editor.vue';
import TranslationsBar from '../components/Translations/TranslationsBar.vue';

export default {
  name: 'GeotagShow',
  components: {
    MediaGeotagPoiImages,
    MediaGeotagImages,
    TranslationsBar,
    AudioList,
    AudioDialogAdd,
    AudioDialogSet,
    AudioDialogUnset,
    VideoCard,
    ImageCard,
    draggable,
    Editor,
    TextCard,
  },
  data: () => ({
    pageTab: null,
    audioId: null,
    audioPlaylists: [],
    listId: null,
    audioLoading: false,
    toRequestAudioList: false,
    geotag: {
    },
    placenames: {},
    newAudioDialog: {
      show: false,
      file: null,
      loading: false,
      disabled: false,
      geotagId: null,
    },
    setAudioDialog: {
      show: false,
      toDefault: false,
    },
    unsetAudioDialog: {
      show: false,
    },
    audioItems: [],

    snapshotDialog: {
      isOpen: false,
      imageSrc: null,
      width: NaN,
      height: NaN,
      originWidth: NaN,
      originHeight: NaN,
    },

    snapshotSlider: {

    },

    sequencedGeotags: [],
    searchloading: false,
    videoLoading: true,
    model: [],
    searchResults: [],
    selectitems: {
      poi: [],
      poiTag: [],
      geotag: [],
    },
    values: [],
    videoPlaylist: [],
    deepLinksList: [],
    search: {
      poiName: null,
      poiTag: null,
      geotag: null,
    },
    select: {
      poiName: null,
      poiTag: null,
      geotag: null,
      geotagId: null,
      priority: [],
      onlyForGeotagSequence: true,
      withNullGeotag: true,
    },
    placenamesDialog: {
      show: false,
      loading: false,
      placenames_id: null,
      isPlacenamesMatched: false,
      isPlacenamesRequested: false,
      placenamesName: '',
    },
    textDialog: {
      show: false,
      loading: false,
      type: null,
      text: null,
      editor: null,
    },
    placenamesExc: null,
    translationsDescription: {},
  }),
  created() {
    this.listId = Number(this.$route.params.id);
    this.debouncedSearchPoi = debounce(this.searchPoi, 500);
    this.debouncedSearchPoiTag = debounce(this.searchPoiTag, 500);
    this.select.geotagId = this.listId;

    this.getGeotag();

    this.$requestHelpers
      .get('api/admin/audio/playlists/geotag')
      .then((response) => {
        this.audioPlaylists = response.data.filter(
          (item) => item.id !== this.listId,
        );
      });

    this.$requestHelpers
      .get(`api/admin/audio/playlist/geotag/${this.listId}`)
      .then((response) => {
        this.audioItems = response.data;
      });

    this.$requestHelpers
      .get(`api/admin/geotag/getSequenced/${this.listId}`)
      .then((response) => {
        this.sequencedGeotags = response.data;
        return this.sequencedGeotags;
      });

    this.$requestHelpers
      .get(`api/admin/geotag/video/${this.listId}`)
      .then((response) => {
        this.videoPlaylist = response.data;
      });
  },
  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    getGeotag() {
      this.$requestHelpers
        .get(`api/admin/geotag/${this.listId}`)
        .then((response) => {
          this.geotag = response.data.result;
          this.getTranslationsDescription();

          if (this.geotag.placenames_id) {
            this.$requestHelpers
              .post('api/admin/placenames', {
                placenames: [this.geotag.placenames_id],
                onlyMainData: false,
              })
              .then((res) => {
                if (res.data[this.geotag.placenames_id]) {
                  this.placenames = res.data[this.geotag.placenames_id];
                }

                this.getPlacenamesExceptions();
              });
          }
        });
    },

    addAudio(status) {
      if (!status) {
        this.setSnack({
          color: 'red',
          text: 'error',
        });
        this.newAudioDialog.show = false;
        this.newAudioDialog.loading = false;
        this.newAudioDialog.file = null;
        this.newAudioDialog.disabled = false;
        return;
      }

      this.setSnack({
        color: 'green',
        text: 'saved',
      });

      this.audioListRequest();
      this.newAudioDialog.show = false;
      this.newAudioDialog.loading = false;
      this.newAudioDialog.file = null;
      this.newAudioDialog.disabled = false;
    },

    audioListRequest() {
      this.audioLoading = true;
      this.$requestHelpers
        .get(`api/admin/audio/playlist/geotag/${this.listId}`)
        .then((response) => {
          this.audioItems = response.data;
          this.audioLoading = false;
        });
    },

    callSetAudioDialog(audioId, toDefault = false) {
      this.audioId = audioId;
      this.setAudioDialog.show = true;
      this.setAudioDialog.toDefault = toDefault;
    },

    callUnsetAudioDialog(audioId) {
      this.audioId = audioId;
      this.unsetAudioDialog.show = true;
    },

    cancelSetDialog() {
      this.setAudioDialog.show = false;
      this.audioId = null;
    },

    cancelUnsetDialog() {
      this.setAudioDialog.show = false;
      this.audioId = null;
    },

    setAudio(status) {
      if (!status) {
        this.setSnack({
          color: 'red',
          text: 'error',
        });
        return;
      }
      this.setSnack({
        color: 'green',
        text: 'saved',
      });

      this.audioListRequest();
      this.setAudioDialog.show = false;
      this.audioId = null;
    },

    unsetAudio(status) {
      if (!status) {
        this.setSnack({
          color: 'red',
          text: 'error',
        });
      } else {
        this.setSnack({
          color: 'green',
          text: 'saved',
        });
      }
      this.audioListRequest();
      this.unsetAudioDialog.show = false;
      this.audioId = null;
    },

    deleteVideo(id) {
      this.$confirm('Are you sure you want to delete this video from playlist?').then((res) => {
        if (!res) return;
        this.$requestHelpers.post(`api/admin/geotag/video/${this.listId}`, {
          delete: id,
        }).then(() => {
          this.videoPlaylist = this.videoPlaylist.filter((video) => video.id !== id);
        });
      });
    },

    deleteDeepLinkImage(id) {
      this.$requestHelpers
        .delete(`api/admin/deeplink/${id}`)
        .then(() => {
          this.geotag.deep_link_images = this.geotag.deep_link_images
            .filter((el) => el.id !== id);
        });
    },

    addDraggedVideo(evt) {
      if (!evt.added) {
        return;
      }
      this.searchResults = this.searchResults.filter(
        (searchvideo) => searchvideo.id !== evt.added.element.id,
      );

      this.$requestHelpers.post(`api/admin/geotag/video/${this.listId}`, {
        add: evt.added.element.id,
      });
    },

    addVideo(video) {
      this.videoPlaylist.push(video);
      this.searchResults = this.searchResults.filter(
        (searchvideo) => searchvideo.id !== video.id,
      );
      this.$requestHelpers.post(`api/admin/geotag/video/${this.listId}`, {
        add: video.id,
      });
    },

    searchPoi(val) {
      this.$requestHelpers.get('api/admin/pois/searchByTermInSequence',
        {
          params: {
            term: val,
            geotag_id: this.listId,
          },
        })
        .then((response) => {
          this.selectitems.poi = response.data;
        });
    },

    searchPoiTag(val) {
      this.$requestHelpers.get('api/admin/poitag/searchByTerm',
        { params: { term: val } })
        .then((response) => {
          this.selectitems.poiTag = response.data;
        });
    },

    getVideo() {
      this.searchloading = true;

      this.$requestHelpers.get('api/admin/videodata',
        { params: this.select })
        .then((response) => {
          this.searchResults = response.data.filter(
            (searchres) => this
              .videoPlaylist.find((video) => video.id === searchres.id) === undefined,
          );
          this.searchloading = false;
        });
    },

    changePlacenames() {
      if (!this.placenamesDialog.placenames_id) {
        return;
      }

      this.$requestHelpers.post(`api/admin/geotag/placenames/${this.listId}`, {
        placenames_id: this.placenamesDialog.placenames_id,
      }).then((response) => {
        if (response.data.success) {
          this.getGeotag();
        }
      }).finally(() => {
        this.placenamesDialog.show = false;
        this.resetPlacenamesDialog();
      });
    },

    updateDistance() {
      this.$refs.distanceDialog.save();
      this.update(
        {
          distance: this.geotag.distance,
        },
        'distance',
      );
    },

    getPlacenamesExceptions() {
      if (!this.placenames.ID) {
        return;
      }

      this.$requestHelpers.post('api/admin/placenames/exceptions', {
        placenames_id: this.placenames.ID,
      }).then((response) => {
        if (response.data.content) {
          this.placenamesExc = response.data.content;
        }
      });
    },

    getTranslationsDescription() {
      this.$requestHelpers.post(
        'api/admin/translations',
        {
          model: this.$constants.TRANSLATION_MODELS.GEOTAG_DESCRIPTION,
          id: this.listId,
        },
      ).then((response) => {
        this.translationsDescription = response.data.result;
      });
    },

    checkPlacenamesID() {
      this.placenamesDialog.isPlacenamesMatched = false;

      this.$requestHelpers
        .post('api/admin/placenames', {
          placenames: [this.placenamesDialog.placenames_id],
          onlyMainData: true,
        })
        .then((response) => {
          if (response.data[this.placenamesDialog.placenames_id]) {
            this.placenamesDialog.isPlacenamesMatched = true;
            this.placenamesDialog
              .placenamesName = response.data[this.placenamesDialog.placenames_id].Name;
          } else {
            this.placenamesDialog.placenamesName = '<not found>';
          }
        }).finally(() => {
          this.placenamesDialog.isPlacenamesRequested = true;
        });
    },

    resetPlacenamesDialog() {
      this.placenamesDialog.placenames_id = null;
      this.placenamesDialog.placenamesName = '';
      this.placenamesDialog.isPlacenamesMatched = false;
      this.placenamesDialog.isPlacenamesRequested = false;
    },

    openSnapshotDialog(image) {
      this.snapshotDialog.imageSrc = image.public_link;
      this.snapshotDialog.width = image.params && image.params.width
        ? image.params.width : NaN;
      this.snapshotDialog.height = image.params && image.params.height
        ? image.params.height : NaN;
      this.snapshotDialog.originWidth = image.params && image.params.origin_width
        ? image.params.origin_width : NaN;
      this.snapshotDialog.originHeight = image.params && image.params.origin_height
        ? image.params.origin_height : NaN;
      this.snapshotDialog.isOpen = true;
    },

    closeSnapshotDialog() {
      this.snapshotDialog.isOpen = false;
    },

    showTextDialog(type = 'description', editor) {
      let text = '';

      switch (type) {
        case 'description':
          text = this.geotag.description;
          break;
        default:
          text = '';
      }
      Object.assign(
        this.textDialog,
        {
          show: true,
          type,
          text,
          editor,
        },
      );

      this.$store.commit('richeditor/setText', text);
    },

    hideTextDialog() {
      Object.assign(
        this.textDialog,
        {
          show: false,
          type: null,
          text: '',
          editor: null,
        },
      );
    },

    saveText() {
      const preparedText = this.textDialog.text
        .trim().substring(0, this.$constants.GEOTAG.MAX_DESCRIPTION_LENGTH);

      this.update(
        {
          [this.textDialog.type]: preparedText,
          show_geotag: true,
        },
        this.textDialog.type,
      ).finally(() => {
        this.hideTextDialog();
      });
    },

    update(request, origField) {
      const modifiedItem = { ...this.listId, ...request };

      return this.$requestHelpers
        .patch(`api/admin/geotag/${this.listId}`, modifiedItem)
        .then((response) => {
          this.geotag[origField] = response.data.result[origField];
        });
    },

  },
  computed: {
    audioDescription() {
      if (this.audioId == null) {
        return '';
      }

      return this.audioItems.reduce(
        (prev, item) => `${prev}${item.id === this.audioId ? item.description : ''}`, '',
      );
    },

    checkButtonClass() {
      if (!this.placenamesDialog.isPlacenamesRequested) {
        return '';
      }

      if (this.placenamesDialog.isPlacenamesMatched) {
        return 'success';
      }

      return 'error';
    },

    chunckedSnapshotList() {
      const listByThree = [];
      if (!this.geotag.deep_link_images) {
        return listByThree;
      }

      for (let i = 0; i < this.geotag.deep_link_images.length; i += 3) {
        listByThree.push(this.geotag.deep_link_images.slice(i, i + 3));
      }
      return listByThree;
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'search.poiTag': function (val) {
      if (!val || val.length < 2) return;
      this.debouncedSearchPoiTag(val);
    },
    // eslint-disable-next-line func-names
    'search.poiName': function (val) {
      if (!val || val.length < 2) return;
      this.debouncedSearchPoi(val);
    },
    // eslint-disable-next-line func-names
    'placenamesDialog.placenames_id': function () {
      this.placenamesDialog.isPlacenamesRequested = false;
    },
    // eslint-disable-next-line func-names
    'placenamesDialog.show': function () {
      this.resetPlacenamesDialog();
    },
  },
};
</script>

<style scoped>
.v-tab {
  text-transform: initial;
}
.playlist-content {
  width: 100%;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-align-content: flex-start;
  -ms-flex-line-pack: start;
  align-content: flex-start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
}
.card-actions {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0;
}
.placenames-id {
  cursor: pointer;
}
.placenames-list {
  column-count: 4;
}
.placenames-exc {
  max-width: 720px;
}
</style>
<style>
.placenames-exc .row {
  display: table-row;
}
</style>
